import { render, staticRenderFns } from "./AdminClientsProductsManagement.vue?vue&type=template&id=51ceef8f&scoped=true&"
import script from "./AdminClientsProductsManagement.vue?vue&type=script&lang=js&"
export * from "./AdminClientsProductsManagement.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientsProductsManagement.vue?vue&type=style&index=0&id=51ceef8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ceef8f",
  null
  
)

export default component.exports